import { radar } from '@/common/log';

interface IExtra {
    position?: string;
    data?: any;
    [key: string]: any;
}

export function reportCatchError(e: Error, extra?: IExtra) {
    const name = e?.name;
    //http业务逻辑错误：error.name 为 undefined。双端验收
    //http网络超时或者http server error：error.name 为Error。双端验收
    if (!name || name === 'Error') {
        return;
    }
    radar.event({
        name: 'KrnCatchError',
        params: {
            type: name,
            message: e?.message,
            stack: e?.stack?.slice(0, 2000), // 最多 2000 个字符，经过本地测试验证通过
            extra: JSON.stringify(extra || {}),
        },
    });
}
